import { useEffect, useState } from "react";
import { fetchProssimoRitiro, oggiIso, type Prenotazione } from "@/features/ritiri/api";

/** Il prossimo ritiro SDA per il riquadro fisso della lista ordini.
 *
 * `undefined` = ancora in lettura, `null` = nessun ritiro, `"errore"` = lettura fallita.
 * In mock mode non legge nulla. Fuori da `OrdiniPage.tsx`, gia' oltre il tetto righe. */
export function useProssimoRitiro(isMockMode: boolean): Prenotazione | null | "errore" | undefined {
  const [prossimo, setProssimo] = useState<Prenotazione | null | "errore" | undefined>(undefined);
  useEffect(() => {
    if (isMockMode) return undefined;
    // ponytail: letto una volta per visita alla lista; un ritiro si prenota
    // dalla pagina Ritiri, e tornando qui la lista si rimonta.
    fetchProssimoRitiro(oggiIso()).then(setProssimo, () => setProssimo("errore"));
  }, [isMockMode]);
  return prossimo;
}
